import HttpClientToken from '../../services/HttpClientToken';

import { TipoSesionProps } from '../../interfaces/catalogos/TipoSesionInterface';

export const TiposSesion = () => {

    return new Promise<TipoSesionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.get('/Api/TipoSesion/', token)
            .then( ({ data } : { data : TipoSesionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ObtenerTipoSesiones = () => {

    return new Promise<TipoSesionProps[]>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.get('/Api/TipoSesion/ObtenerTipoSesiones', token)
            .then( ({ data } : { data : TipoSesionProps[] } ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( [] );
            });
        }

    });

}

export const ActualizarTipoSesion = ( params: TipoSesionProps ) => {

    return new Promise<TipoSesionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.post('/Api/TipoSesion/Actualizar', params, token)
            .then( ({ data } : { data : TipoSesionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoSesion: 0,                 
                    descripcion: '',
                    activo: false,     
                });
            });
        }

    });

}

export const AgregarTipoSesion = ( params: TipoSesionProps ) => {

    return new Promise<TipoSesionProps>( (resolve, eject) => {

        const data = JSON.parse( window.localStorage.getItem('data') ?? '' );

        if( data ){
            const { token } = data;

            HttpClientToken.post('/Api/TipoSesion/Agregar', params, token)
            .then( ({ data } : { data : TipoSesionProps} ) => {               
                resolve( data );                
            })
            .catch( () => {
                resolve( {
                    idTipoSesion: 0,
                    descripcion: '',
                    activo: false,    
                });
            });
        }

    });

}